import { render, staticRenderFns } from "./NewTabs.vue?vue&type=template&id=5b5bb4be&scoped=true"
import script from "./NewTabs.vue?vue&type=script&lang=js"
export * from "./NewTabs.vue?vue&type=script&lang=js"
import style0 from "./NewTabs.vue?vue&type=style&index=0&id=5b5bb4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5bb4be",
  null
  
)

export default component.exports